import * as XState from "xstate";
import cabri from "../../app/cabri-app";
import {LOG} from '../../app/log'


let gesture = cabri.gestureHandler;
const Direction = {VERTICAL: "VERTICAL", HORIZONTAL: "HORIZONTAL"};

const noMouse = () => {
    return !gesture.hasMouse || !gesture.isFocussed;
};
const mouseIsOnObject = () => {
    return gesture.hasMouse && gesture.isFocussed &&
        gesture.touchedGeomObject;
};


// fields of the tool
// ... because this is a singleton, we can use the module properties
//     as local fields and avoid using the context which may be
//     observed in its full depth.

let movedObject = null;
let permanent = true;
let movingDirection =  Direction.HORIZONTAL;

if (typeof (window) !== "undefined") window.XState = XState;

const states = {
    "selected": {
        always: [ // direct jump depending on the device type
            {
                cond: noMouse,
                target: "available_but_invisible",
            },
            {
                cond: mouseIsOnObject,
                target: "rollover_movable",
            },
            {
                target: "rollover_nothing",
            },
        ],
    },
    available_but_invisible: {
        on: {
            PICK: {
                actions: ["picked"],
                target: "object_selected",
            },
            CANCEL: { target: "inactive" }
        },
    },
    "rollover_nothing": {
        on: {
            PICK: {
                actions: ["picked"],
                target: "object_selected",
            },
            CANCEL: { target: "inactive" }
        },
    },
    "rollover_movable": {
        on: {
            LEAVE: {
                actions: ["unpicked"],
                target: "rollover_nothing",
            },
            PICK: {
                actions: ["picked"],
                target: "object_selected"
            },
            CANCEL: { target: "inactive" }
        },
    },
    object_selected: {
        always: [ // auto-jump depending on pressed keys
            {
                cond: () => !gesture.shouldMoveVertically, // TODO: gesture
                                                           // interface
                                                           // differently
                target: "object_moving_horizontal",
            },
            {
                cond: () => gesture.shouldMoveVertically,
                target: "object_moving_vertical",
            },
        ],
    },
    object_moving_horizontal: {
        on: {
            MOVE: {target: undefined, actions: ["updateCoordinateH"]},
            CANCEL: {target: "have_operated", actions: ["undoInitiatedMove"]},
            CHANGE_DIR: {target: "object_moving_vertical"},
            DROP: {target: "have_operated", actions: ["unpicked"]},
        },
    },

    object_moving_vertical: {
        on: {
            MOVE: {target: undefined, actions: ["updateCoordinateV"]},
            CANCEL: {target: "have_operated", actions: ["undoInitiatedMove"]},
            CHANGE_DIR: {target: "object_moving_horizontal"},
            DROP: {target: "have_operated", actions: ["unpicked"]},
        },
    },

    have_operated: {
        always: [
            {cond: () => "isPermanent", target: "selected"},
            {cond: () => "isNotPermanent", target: "finished"},
        ],
    },

    inactive: {
        on: {
            ACTIVATE: {target: "selected", actions: ["initGestures"]},
        },
    },

    finished: {
        type: "final",
    },

};

/* Object.keys(buttonMachine.states).forEach((key)=> {
 if(typeof(states[key])!=="object") {
 states[key] = buttonMachine.states[key];
 }
 }); */

function updateCoords(o) {
    if ( o.getCoords && o.updateFromPeer) {
        o.updateFromPeer();
        const c = o.getCoords();
        cabri.lastPointerCoord = {x: c[0], y:c[1], z:c[2]};
        cabri.notifyFileDirty();
    }
}
export default XState.Machine({
        id: "move_tool",
        initial: "inactive",
        context: {
        },
        states: states,
    },
    {
        actions: {
            picked: function (ctx, evt) {
                LOG.for("move-tool-state") && LOG.info("Picked: ", evt.touchedGeomObject);
                movedObject = evt.touchedGeomObject;
                if(movedObject) console.log("picked! ", movedObject);
                // TODO: capture an original coordinate (depends on the object
                // type) originalCoordinates = movedObject.
            },

            unpicked: function (ctx, evt) {
                LOG.for("move-tool-state") && LOG.info("Unpicked: ", movedObject);
                movedObject = null;
            },

            updateCoordinateV: function (ctx, evt) {
                movingDirection = Direction.VERTICAL;
                cabri.notifyFileDirty();
                const o = movedObject;
                if (o.dragAlongRay) {
                    o.dragAlongRay(evt.pointerInfo.pickInfo.ray,
                        evt.pointerInfo.pickedPoint, true);
                    updateCoords(movedObject);
                }
            },
            updateCoordinateH: function (ctx, evt) {
                movingDirection = Direction.HORIZONTAL;
                cabri.notifyFileDirty();
                if (movedObject.dragAlongRay) {
                    movedObject.dragAlongRay(evt.pointerInfo.pickInfo.ray,
                        evt.pointerInfo.pickedPoint, false);
                    updateCoords(movedObject);
                }
            },
            undoInitiatedMove: function (ctx, evt) {
                if (originalCoordinates) {
                    movedObject.setPosition(xx); // TODO
                }
                console.log("TODO: undoInitiatedMove: ", ctx, evt);
            },
            checkPermanent: (ctx, evt) => {
                if (evt.doubleClicked) {
                    permanent = true;
                }
            },
            initGestures: (ctxt, evt) => {
                // needed because the first gesture-handler as imported is
                // going to be empty.
                gesture = cabri.gestureHandler;
            },
        },

        guards: {
            isPermanent: () => {
                return permanent;
            },
            isNotPermanent: () => {
                return !permanent;
            },
        },
    },
);
